<template>
  <div>
    <div class="py-10 px-5 max-w-4xl mx-auto">
      <p class="text-2xl font-bold pb-3 mb-10 text-center border-b border-gray-300">
        联系方式
      </p>
      <div class="max-w-sm mx-auto text-center mt-5">
        <p>
          <span class="font-bold align-middle">邮箱：</span>
          <span class="font-mono text-gray-700 text-sm align-middle">zhangshaolei20z@ict.ac.cn</span>
        </p>
      </div>
    </div>
  </div>
</template>>

<script>
export default {
  metaInfo: {
    title: "联系我们"
  }
}
</script>